import { SearchAndCoursesConstants } from '../constants/search_and_add_courses_constants';
import { IApplicationConfiguration } from '../../interfaces/scheduler_interfaces';

export class SearchAndCourseFeatureFacade {
  constructor(private appConfigModel: IApplicationConfiguration) {}

  get isFeatureEnabled() {
    return this.appConfigModel.isFeatureEnabled(SearchAndCoursesConstants.FEATURE_TOGGLE_NAME);
  }
}

angular.module('capability-ng-scheduler').service('ngSearchAndCourseFeatureFacade', SearchAndCourseFeatureFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/facades/search_and_courses_feature_facade.ts